import React, { useEffect, useState } from "react"
import { NumericFormat } from "react-number-format"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"
import { getProductAttr } from "@/utils/product"
import CartServiceIcon from "@/public/icons/install-service-cart-icon.svg"
import MissingImage from "@/public/images/image-missing.png"
import Image from "next/image"

const ReturnListItemTile = ({
  isReturns,
  curstep,
  brandName = "",
  currencySign,
  item = {},
  staticText = {},
  getItems = () => {},
  returnList = [],
  handleReturnData = () => {},
  quantityVal = "",
  returnVal = "",
  totalQuantity = "",
  isReturnConfirmed = false,
  returnedItems = {},
  errorMsg = "",
  setErrorMsg = () => {},
}) => {
  const [quantity, setQuantity] = useState(1)
  const [returnData, setReturnData] = useState(returnVal ? returnVal : "")
  const {
    itemName = "",
    price = "",
    sku = "",
    description = "",
    lwData = {},
    orderQty = "",
    udf2 = "",
    udf1 = "",
    discAmount = "",
    udf6 = "",
  } = item

  const getQuantity = val => {
    let resultData = []
    for (let i = 1; i <= val; i++) {
      resultData.push(i)
    }
    return resultData
  }
  const productData = getProductAttr(sku, lwData)

  const handleQuantity = val => {
    const getPrice = val * price
    setQuantity(val)
    getItems(price, val, getPrice)
  }
  const returnListData =
    returnList.map(list => {
      return list.value
    }) ?? []

  const handlePrice = (priceVal, discount) => {
    const discountAmount = discount / totalQuantity
    const price = priceVal - discountAmount
    return price ?? 0
  }

  return (
    <>
      <div className="return-listitem__flexleft">
        <div className="return-listitemimg__img">
          <Image
            className={`return-listitem__img ${
              udf2 === "NA for service" ? "installation-img" : ""
            }`}
            src={
              udf2 !== "NA for service" ? productData?.image ? productData.image : MissingImage?.src  : CartServiceIcon
            }
            alt={itemName}
            area-label={itemName}
            width={90}
            height={120}
            aria-description="image of product"
            onError={e => (e.target.src = MissingImage?.src)}
          />
        </div>
        <div className="product-det">
          {udf2 !== "NA for service" ? (
            <>
              <div className="product-det__id">
                <span>{brandName}</span>
                <p className="product-det__sku">{sku}</p>
              </div>
              <p className="product-det__name">{itemName}</p>
              <p className="product-det__measure">{description} </p>
              <p className="product-det__color">{`${staticText.colorFinish}: ${udf2}`}</p>
            </>
          ) : (
            <p className="product-det__installation">
              {staticText.installationService(udf6 !== "" ? udf6 : udf1)}
            </p>
          )}
          {isReturns && curstep === 0 ? (
            <p className="product-det__cost">
              <NumericFormat
                value={handlePrice(price, discAmount)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={currencySign}
                decimalScale={2}
                fixedDecimalScale={true}
                thousandsGroupStyle={"lakh"}
              />
            </p>
          ) : null}
        </div>
      </div>
      <div
        className={`return-listitem__flexright ${
          isReturns && curstep === 0 ? "return-listitem__flexedit" : ""
        }`}
      >
        {isReturns && curstep === 0 ? (
          <>
            <Dropdown
              id="return-listitem__quantity"
              customClass="quantity-field"
              data={getQuantity(Number(quantityVal))}
              value={quantity}
              label={staticText.returnerQuantity}
              onChange={val => handleQuantity(val)}
            />
            {udf2 !== "NA for service" ? (
              <>
                <Dropdown
                  id="return-listitem__reason"
                  customClass="returnreason-field"
                  data={returnListData}
                  value={returnData}
                  label={staticText.reasonForReturn}
                  onChange={val => {
                    handleReturnData(val), setErrorMsg(""), setReturnData(val)
                  }}
                />
                {errorMsg !== "" ? (
                  <p className="reason-error">{errorMsg}</p>
                ) : null}
              </>
            ) : null}
          </>
        ) : (
          <>
            <div className="return-listitem__checked--details">
              <h4>{staticText.returnerQuantity}</h4>
              <p>{isReturnConfirmed ? returnedItems?.quantity : quantity}</p>
            </div>
            {udf2 !== "NA for service" ? (
              <div className="return-listitem__checked--details">
                <h4>{staticText.returnReason}</h4>
                <p>{returnData !== "" ? returnData : staticText.noReason}</p>
              </div>
            ) : null}
          </>
        )}
      </div>
    </>
  )
}

export default ReturnListItemTile
